/* GODS & KINGS — route every Ingredients navigation link to the dedicated Ingredient Atlas page. */
(function(){
  function routeIngredients(root){
    (root||document).querySelectorAll('a[href="/#ingredients"],a[href="#ingredients"]').forEach(function(a){
      a.setAttribute('href','/pages/ingredients');
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){routeIngredients(document)});else routeIngredients(document);
  document.addEventListener('shopify:section:load',function(e){routeIngredients(e.target)});
})();
